// Modern Alert Service - Replaces toastify
import alertService from './alertService';

const toastify = {
    success: (message) => {
        alertService.success(message);
    },
    error: (message) => {
        alertService.error(message);
    },
    info: (message) => {
        alertService.info(message);
    },
    warning: (message) => {
        alertService.warning(message);
    },
    default: (message) => {
        alertService.default(message);
    }
};

export default toastify;